export const PublicOptions = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'Speakers',
    link: '/speakers',
  },
  {
    label: 'Event Program',
    link: '/schedule',
  },
  {
    label: 'Abstracts instructions',
    link: '/abstracts-instructions',
  },
  {
    label: 'Workshops',
    link: '/workshops',
  },
  {
    label: 'Travel & Accommodation',
    link: '/hotels',
  },
  {
    label: 'About',
    link: '/about',
  },
];
